import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-78cc5ac6")

_pushScopeId("data-v-78cc5ac6")
const _hoisted_1 = { class: "container col align-center" }
const _hoisted_2 = { class: "w-full flex" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重爬")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_search_input = _resolveComponent("search-input")
  const _component_PDFUploader = _resolveComponent("PDFUploader")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_crawl_book_dialog = _resolveComponent("crawl-book-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_search_input, {
          modelValue: _ctx.searchName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchName = $event)),
          placeholder: "输入书名进行搜索",
          onSearch: _ctx.handleSearch
        }, null, 8, ["modelValue", "onSearch"]),
        _hoisted_3,
        _createVNode(_component_PDFUploader, { onSuccess: _ctx.bookCrawled }, null, 8, ["onSuccess"])
      ]),
      _createVNode(_component_el_table, {
        data: _ctx.tableData.content,
        height: "100%",
        onRowClick: _ctx.handleRowClick,
        class: "w-full"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            prop: "title",
            label: "名称"
          }),
          _createVNode(_component_el_table_column, { label: "来源" }, {
            default: _withId(({row}) => [
              _createTextVNode(_toDisplayString(_ctx.getSource(row).name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "author",
            label: "作者"
          }),
          _createVNode(_component_el_table_column, {
            prop: "coverImg",
            label: "封面"
          }, {
            default: _withId((scope) => [
              _createVNode(_component_el_image, {
                class: "cover",
                src: scope.row.coverImg
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "shareDescription",
            "show-overflow-tooltip": "",
            label: "简介"
          }),
          _createVNode(_component_el_table_column, {
            prop: "charSize",
            label: "字数"
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_4, [
                (['jd', '163'].indexOf(_ctx.getSource(scope.row).code) > -1)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: "margin-right-10",
                      size: "small",
                      type: "warning",
                      onClick: _withModifiers(($event: any) => (_ctx.reCrawl(scope.row)), ["stop"])
                    }, {
                      default: _withId(() => [
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  size: "small",
                  class: "margin-right-10",
                  onClick: ($event: any) => (_ctx.handleRowClick(scope.row)),
                  type: "success"
                }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_popconfirm, {
                  onConfirm: ($event: any) => (_ctx.deleteBook(scope.row)),
                  title: "确定删除吗？"
                }, {
                  reference: _withId(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger"
                    }, {
                      default: _withId(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onRowClick"]),
      _hoisted_8,
      _createVNode(_component_el_pagination, {
        class: "margin-top-10",
        total: _ctx.tableData.totalCount,
        "page-count": _ctx.tableData.totalPages,
        "current-page": _ctx.tableData.pageNumber,
        onCurrentChange: _ctx.reloadPage,
        onPrevClick: _ctx.reloadPage,
        onNextClick: _ctx.reloadPage,
        background: "",
        layout: "total, prev, pager, next, jumper"
      }, null, 8, ["total", "page-count", "current-page", "onCurrentChange", "onPrevClick", "onNextClick"])
    ]),
    _createVNode(_component_crawl_book_dialog, {
      bookId: _ctx.currentBookId,
      bookSource: _ctx.currentBookSource,
      modelValue: _ctx.crawlDialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.crawlDialogVisible = $event)),
      onSuccess: _ctx.bookCrawled
    }, null, 8, ["bookId", "bookSource", "modelValue", "onSuccess"])
  ], 64))
})